import { Cart } from '@/models/cart/cart'
import { CartItem, NewCartItem } from '@/models/cart/cart-item'
import { CartItemRepository } from '../repository/cart-item-repository'
import { DefaultDealWithItemViaCartSpec } from '../specification/deal-with-item-via-cart/default-deal-with-item-via-cart-spec'
import {
  CommandResult,
  CommandResultContainer,
  DealWithItemViaCartSpec,
} from '../specification/deal-with-item-via-cart/index'
import { itemShouldExistInCart } from './assertion'

export class RestoreRemovedItemFromCartService {
  static create(repository: CartItemRepository): RestoreRemovedItemFromCartService {
    return new RestoreRemovedItemFromCartService(
      repository,
      new DefaultDealWithItemViaCartSpec()
    )
  }
  private constructor(
    private readonly repository: CartItemRepository,
    private readonly dealWithItemViaCartSpec: DealWithItemViaCartSpec
  ) { }

  async restore(item: CartItem, cart: Cart): Promise<CommandResult> {
    const command = this.dealWithItemViaCartSpec.apply(async (itemOnRun, cartOnRun) => {
      try {
        itemShouldExistInCart(itemOnRun, cartOnRun)

        return this.repository.add(NewCartItem.createFromCartItem(itemOnRun)).then(r => r.fold(
          e => CommandResultContainer.createAsFail([e]),
          () => CommandResultContainer.createAsSuccess({
            ...itemOnRun,
            removed: false,
          })
        ))
      } catch (e) {
        return CommandResultContainer.createAsFail([e])
      }
    })

    return command(item, cart)
  }
}
